import { Dispatch, SetStateAction, useState } from "react"
import { getPreviousYears, monthYear } from "../../../../../../utils/constants/date_month"
import { GeneralValues } from "../../../../../../utils/types/generals"

export type InputValue = {
    input: GeneralValues
    setInput: Dispatch<SetStateAction<GeneralValues>>
}

export const inputMain = {
    search: {
        label: 'general.search',
        translate: true,
        name: 'search',
        type: 'text',
        value: null,
    },
    createYear: {
        label: 'general.filterDate.year',
        translate: true,
        name: 'createYear',
        type: 'filter-select',
        items: getPreviousYears(),
        value: null,
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    month: {
        label: 'general.filterDate.month',
        translate: true,
        name: 'month',
        type: 'filter-select',
        items: monthYear.map((e) => ({
            ...e,
            value: e.value + 1,
        })),
        value: null,
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    from: {
        label: 'general.tags.from',
        translate: true,
        name: 'from',
        type: 'date',
        value: null,
        rest: {
            max: 'to',
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    to: {
        label: 'general.tags.to',
        translate: true,
        name: 'to',
        type: 'date',
        value: null,
        rest: {
            min: 'from',
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
            xs: 6,
        },
    },
    areas: {
        label: 'general.tags.area',
        translate: true,
        name: 'areas',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
    },
    departments: {
        label: 'general.tags.department',
        translate: true,
        name: 'departments',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
    },
    catalog: {
        label: 'general.tags.catalog',
        translate: true,
        name: 'catalog',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
    },
} as GeneralValues

export const useInputForm = (payload?: { isEdit: boolean }): GeneralValues => {
    return {
        areas: {
            label: 'general.tags.area',
            translate: true,
            name: 'areas',
            type: payload?.isEdit ? 'select-search' : 'filter-select',
            items: [],
            value: null,
            validate: { required: true, },
            rest: {
                fullWidth: true,
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 12,
            }
        },
        departments: {
            label: 'general.tags.department',
            translate: true,
            name: 'departments',
            type: payload?.isEdit ? 'select-search' : 'filter-select',
            items: [],
            value: null,
            validate: { required: true, },
            rest: {
                fullWidth: true,
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 12,
            }
        },
        preventiveCatalog: {
            label: `general.tags.preventiveCatalog`,
            translate: true,
            name: 'preventiveCatalog',
            type: 'select-search',
            items: [],
            value: null,
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 12,
            }
        },
        correctiveCatalog: {
            label: `general.tags.correctiveCatalog`,
            translate: true,
            name: 'correctiveCatalog',
            type: 'select-search',
            items: [],
            value: null,
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 12,
            }
        },
    }
}

export const useInput = (payload?: { form: GeneralValues }): InputValue => {
    const [input, setInput] = useState<GeneralValues>(payload?.form ?? inputMain)
    return {
        input,
        setInput
    }
}